import voiceOfNigeriaResidence from './voice-of-nigeria-residence';
import aurenResidence from './auren-residence';

// Order here is the default display order on /projects (featured is lifted out
// and shown first regardless).
export const PROJECTS = [voiceOfNigeriaResidence, aurenResidence];

export const getAllProjects = () => PROJECTS.filter((p) => p.listed);

export const getFeaturedProject = () =>
  PROJECTS.find((p) => p.featured && p.listed) ?? getAllProjects()[0] ?? null;

export const getProjectBySlug = (slug) =>
  PROJECTS.find((p) => p.slug === slug) ?? null;

export const getOtherProjects = (slug, limit = 3) =>
  getAllProjects()
    .filter((p) => p.slug !== slug)
    .slice(0, limit);
